import { Endpoints } from "../../../constants/endpoints";
import { TStaticsRaw } from "./types";
import client from "../../client";

export const getStatics = async () => {
  const { data } = await client.get<TStaticsRaw>(Endpoints.getStatic);
  return data;
};
